import { useEffect } from 'react';
import { compose } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

import Error from 'core/errors/Error';
import withAppState from 'hoc/withAppState';
import PageContent from 'layouts/PageContent';
import FlashPaymentWebhookLogs from 'components/flash-payment-webhook-logs/FlashPaymentWebhookLogs';
import WebhookLogModal from 'components/flash-payment-webhook-logs/WebhookLogModal';
import { resetGetFlashPaymentWebhookLogsFailure } from 'app/features/flash-payment-webhook-logs/flashPaymentWebhookLogSlice';

function ListFlashPaymentWebhookLogs({ isNetworkError }) {
  const logsState = useSelector((state) => state.flashPaymentWebhookLogs.index);

  const { isError, errorCode } = logsState;

  const dispatch = useDispatch();

  useEffect(() => {
    if (isError) dispatch(resetGetFlashPaymentWebhookLogsFailure());
  }, [isNetworkError]);

  if (isError)
    return (
      <Error
        status={errorCode}
        withInDashboard={true}
        onRetry={() => dispatch(resetGetFlashPaymentWebhookLogsFailure())}
      />
    );

  return (
    <PageContent title="Webhook Logs">
      <FlashPaymentWebhookLogs />
      <WebhookLogModal />
    </PageContent>
  );
}

export default compose(withAppState)(ListFlashPaymentWebhookLogs);
